import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-groups-button',
  templateUrl: './groups-button.component.html',
  styleUrls: ['./groups-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip],
})
export class GroupsButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
